import { CityState, DataSource, Label, Layout, Location, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutStopShowAs extends Layout {
	citystateShowAs: CityState;
	labelCreatingLocation: Label;
	labelDevInfo: Label;
	labelShowAs: Label;
	locationShowas: Location;
	panelShowAs: Panel;
	sourceStop: DataSource;
	tabShowAs: Tab;
	tabStop: Tab;
	tabsetShowAs: Tabset;
	textboxShowasAddress2: Textbox;
	textboxShowasAddress: Textbox;
	textboxShowasLocationId: Textbox;
	textboxShowasLocationName: Textbox;
}
